import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import styles from "./ChatbotPanel.module.css";

const normalizeUrlToCurrentHost = (url) => {
  try {
    const targetUrl = new URL(url);
    const { protocol, host } = window.location;

    if (!targetUrl.hostname.includes("nxnearby.com")) {
      return url;
    }

    targetUrl.protocol = protocol;
    targetUrl.host = host;

    return targetUrl.toString();
  } catch {
    return url;
  }
};

const CourseCard = ({ course }) => {
  if (!course) return null;

  const level = course.course_level?.toLowerCase() || "all";

  return (
    <div className={styles.courseResultCard}>
      <div className={styles.courseIcon}>
        <SchoolOutlinedIcon fontSize="small" />
      </div>

      <div className={styles.courseContent}>
        <div className={styles.courseTopRow}>
          <span className={styles.courseTitle}>{course.course_name}</span>

          <a
            href={normalizeUrlToCurrentHost(course.course_url)}
            target="_blank"
            rel="noreferrer"
            className={styles.courseLinkIcon}
            onClick={(e) => e.stopPropagation()}
          >
            <OpenInNewIcon fontSize="small" />
          </a>
        </div>

        {course.description && (
          <p className={styles.courseDesc}>{course.description}</p>
        )}

        <div className={styles.courseMeta}>
          <span
            className={`${styles.levelBadge} ${
              styles[level] || styles.all
            }`}
          >
            {course.course_level}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;
